var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCu = function SvgIconCu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12S0 5.373 0 12c0 6.628 5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a11.98 11.98 0 0 0-9.6 4.8h19.2A11.98 11.98 0 0 0 12 0M12 24c3.926 0 7.411-1.886 9.6-4.8H2.4A11.98 11.98 0 0 0 12 24M0 12c0 .822.083 1.624.24 2.4h23.52a12.05 12.05 0 0 0 0-4.8H.24C.083 10.375 0 11.178 0 12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m4.857 8.87.777 2.391h2.515l-2.035 1.478.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.035-1.478H4.08z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCu;